// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"176":"projects","443":"about"}[chunkId] + "-legacy." + {"176":"559e1f38","443":"22425593"}[chunkId] + ".js";
};